import * as types from './mutations-types';
import ESService from '@/services/ESService';
import { API, graphqlOperation } from 'aws-amplify';
import {
  createSearchResults,
  deleteSearchResults,
  updateSearchResults,
} from '@/graphql/mutations';
import { listSearchResultss } from '@/graphql/queries';
import { getCurUser } from '../../../constants/fromLocalStorageConstants';
import { logError } from '@/utils/loggerUtils';

export const actions = {
  async SEARCH({ commit }, payload) {
    try {
      const response = await ESService.searchRegDocPage({
        q: payload.keyword,
        mode: payload.mode,
        agencyNames: payload.filters.regAgency.selected.join(';'),
        agencyDivisionNames:
          payload.filters.regAgencyDivision.selected.join(';'),
        docCategories: payload.filters.docCategory.selected.join(';'),
        applicationTypes: payload.filters.applicationType.selected.join(';'),
        docSubCategories: payload.filters.docSubCategory.selected.join(';'),
        docTypes: payload.filters.docType.selected.join(';'),
        guidanceTopics: payload.filters.guidanceTopic.selected.join(';'),
        guidanceStatuses: payload.filters.guidanceStatus.selected.join(';'),
        companyNames: payload.filters.companyName.selected.join(';'),
        genericNames: payload.filters.genericName.selected.join('~'),
        brandNames: payload.filters.brandName.selected.join('~'),
        productNames: payload.filters.productName.selected.join('~'),
        productTypes: payload.filters.productType.selected.join(';'),
        indications: payload.filters.indication.selected.join(';'),
        contraIndications: payload.filters.contraIndication.selected.join(';'),
        productClasses: payload.filters.productClass.selected.join(';'),
        priorityReviews: payload.filters.priorityReview.selected.join(';'),
        drugDesignations: payload.filters.drugDesignation.selected.join(';'),
        actionDateStart: payload.actionDateStart,
        actionDateEnd: payload.actionDateEnd,
        offset: payload.offset,
        sortOrder: payload.sortOrder,
      });
      commit(types.SEARCH_RESULTS_SUCCESS, response.data);
    } catch (e) {
      logError(e);
    }
  },
  async SET_SEARCH_SAVE({ commit }, search) {
    try {
      return search;
    } catch (e) {
      logError(e);
      commit();
    }
  },

  async SAVE_SEARCH({ commit }, payload) {
    try {
      const response = await API.graphql(
        graphqlOperation(createSearchResults, {
          input: {
            projectID: payload.projectID,
            title: payload.title,
            description: payload.description,
            query: payload.query,
            mode: payload.mode,
            actionDateStart: payload.actionDateStart,
            actionDateEnd: payload.actionDateEnd,
            filters: JSON.stringify(payload.filters),
            accessGroups: getCurUser().groups,
            prevNumPages: payload.prevNumPages,
          },
        })
      );
      commit(types.SAVE_SEARCH_SUCCESS, response.data.createSearchResults);
    } catch (e) {
      logError(e);
    }
  },
  async UPDATE_SEARCH({ commit }, payload) {
    try {
      const response = await API.graphql(
        graphqlOperation(updateSearchResults, {
          input: {
            id: payload.id,
            prevNumPages: payload.prevNumPages,
          },
        })
      );
      commit(types.SAVE_SEARCH_SUCCESS, response.data.createSearchResults);
    } catch (e) {
      logError(e);
    }
  },
  async DELETE_SEARCH({ commit }, payload) {
    try {
      const response = await API.graphql(
        graphqlOperation(deleteSearchResults, {
          input: {
            id: payload.id,
          },
        })
      );
      commit(types.DELETE_SEARCH_SUCCESS, response.data.deleteSearchResults.id);
    } catch (e) {
      logError(e);
    }
  },
  async FETCH_SAVED_SEARCH({ commit }, payload = null) {
    try {
      const project_id = payload.project_id;
      const searchResults = await API.graphql(
        graphqlOperation(listSearchResultss, {
          filter: {
            projectID: {
              eq: project_id,
            },
          },
        })
      );
      commit(
        types.FETCH_SAVED_SEARCH_SUCCESS,
        searchResults.data.listSearchResultss.items
      );
    } catch (e) {
      logError(e);
    }
  },
};
